export const validateModelName = (name) =>{
    const trimmed = name.trim();

    const regex = /^[a-zA-Z0-9_ ]+$/

    if(trimmed.length > 15)
        return "Model name must be max 15 characters"

    if(!regex.test(trimmed)){
        return "Special characters or newlines are not allowed"
    }
    return ""
}